import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Datestamp from 'app/components/shared/DateStamp';
import { eventShape } from 'app/shapes/events';

export default function EventDateStamp({ event, isCalloutFeatured }) {
  const month = moment(event.getIn(['definition', 'start'])).format('MMM');
  const day = moment(event.getIn(['definition', 'start'])).format('D');

  return (
    <Datestamp className="cp-event-date-stamp" month={month} day={day} size={isCalloutFeatured ? 'large' : 'default'} />
  );
}

EventDateStamp.propTypes = {
  event: eventShape.isRequired,
  isCalloutFeatured: PropTypes.bool
};
